<template lang="pug">
  .container
    video(
      controls=true
      autoplay=true
      playsinline=true
      webkit-playsinline=true
      type="video/mp4"
      :src="videoUrl"
      v-video="videoUrl"
    )
</template>

<style lang="scss" scoped>
$footer-height: 56px;
.container {
  background: rgba(22, 23, 26, 1);
  position: absolute;
  bottom: $footer-height;
  top: $footer-height;
  left: 0;
  right: 0;
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>

<script>
export default {
  props: {
    videoUrl: { type: String },
  },
  directives: {
    video(el, binding) {
      binding.value ? el.play() : el.pause()
    },
  },
}
</script>
